import React, { Component } from "react";
import {
  Collapse,
  Alert,
  FormControl,
  ControlLabel,
  FormGroup,
  Row,
  Col,
  Grid
} from "react-bootstrap";

import { Card } from "../../components/Card/Card.jsx";
import {
  closeNotification,
  createGame
} from "../../services/GameServices";

import Button from "../../elements/CustomButton/CustomButton.jsx";

class CreateGame extends Component {
  constructor(props, context) {
    super(props, context);
    this.handleChangeGame = this.handleChangeGame.bind(this);
    this.handleChangeDate = this.handleChangeDate.bind(this);
    this.handleChangeTime = this.handleChangeTime.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      game: "",
      date: new Date(),
      time: 0,
      alert: "warning",
      status: "UNKNOWN",
      message: "UNKNOWN",
      isShowing: false
    };
  }

  handleChangeGame(e) {
    const target = e.target  
    this.setState({game: target.value});
  }

  handleChangeDate(e) {
    const target = e.target  
    this.setState({date: target.value});
  }

  handleChangeTime(e) {
    const target = e.target  
    this.setState({time: target.value});
  }

  handleSubmit(e) {
    var outsideThis = this;
    this.setState({ isShowing: false });
    const date = this.state.date;
    const time = this.state.time;
    var d = new Date();
    createGame({name: this.state.game, broadCastTime: d})
      .then(function(response) {
        if (response.data.err) {
          outsideThis.setState({
            message: response.data.err.name || response.data.err.code || response.data.err,
            isShowing: true,
            status: "ERROR!",
            alert: "danger"
          });
        } else {
          outsideThis.setState({
            message: "Added a new quiz: " + response.data.game.name,
            isShowing: true,
            status: "SUCCESS!",
            alert: "success"
          });
        }
      })
      .catch(function(err){
        outsideThis.setState({
          message: err.name || err.code || err,
          isShowing: true,
          status: "ERROR!",
          alert: "danger"
        });
      })
      .finally( (args) => {
        closeNotification(this);
      });
  }

  render() {
    return (
      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Collapse in={this.state.isShowing}>
                <Row>
                  <Col xs={6} md={4}>
                    <Alert bsStyle={this.state.alert}>
                      <strong>{this.state.status}</strong> {this.state.message}
                    </Alert>
                  </Col>
                </Row>
              </Collapse>
              <Card
                title="Create  a new Quiz"
                content={
                  <form>
                    <FormGroup controlId="formBasicText">
                      <Row>
                        <Col xs={12} md={8}>
                          <ControlLabel>Name of quiz</ControlLabel>
                          <FormControl
                            type="text"
                            value={this.state.game}
                            placeholder="Enter quiz title"
                            onChange={this.handleChangeGame}
                          />
                        </Col>
                        {/* <Col xs={6} md={4}>
                          <ControlLabel>Date</ControlLabel>
                          <FormControl
                            type="date"
                            value={this.state.date}
                            placeholder="Enter the broadcast time of your quiz"
                            onChange={this.handleChangeDate}
                          />
                        </Col>
                        <Col xs={6} md={4}>
                          <ControlLabel>Time</ControlLabel>
                          <FormControl
                            type="time"
                            value={this.state.time}
                            placeholder="Enter the broadcast time of your game"
                            onChange={this.handleChangeTime}
                          />
                        </Col> */}
                      </Row>
                    </FormGroup>

                    <Button onClick={this.handleSubmit} bsStyle="info" fill>
                      Add Quiz
                    </Button>
                    <div className="clearfix" />
                  </form>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default CreateGame;



// WEBPACK FOOTER //
// ./src/views/Game/CreateGame.jsx